<template>
    <div>
        <!-----ชำระหนี้โครงการ---->
        <b-breadcrumb :items="items"/>
        <div class="container-fluid" style="background-color: white">
            <h2 class="text-center p-3">รายการจ่ายเงิน-จ่ายชำระหนี้</h2>
            <div class="row" style="margin-right: 10px">
                <div class="col-sm-6">
                    <div class="form-group row">
                        <label
                            class="col-sm-4 col-form-label text-capitalize text-right">
                            วันที่จ่ายเงิน
                        </label>
                        <div class="col-sm-8">
                            <date-picker
                                v-model="form.receive_date"
                                class="w-100"
                                :lang="lang"
                                :format="changeFormat"
                                placeholder="วันที่ใบจ่ายเงิน">
                            </date-picker>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label
                            class="col-sm-4 col-form-label text-capitalize text-right">
                            รหัสเจ้าหนี้
                        </label>
                        <div class="col-sm-8">
                            <multiselect
                                v-model="form.vendor"
                                :options="optionVendor"
                                :customLabel="vendorLabel"
                                placeholder="รหัสเจ้าหนี้"
                                @input="getProjectList"
                                :show-labels="false"
                                track-by="id">
                            </multiselect>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label
                            class="col-sm-4 col-form-label text-capitalize text-right">
                            ชื่อโครงการ
                        </label>
                        <div class="col-sm-8">
                            <multiselect
                                v-if="form.projects"
                                v-model="form.projects"
                                :options="optionsProject"
                                label="name"
                                placeholder="โครงการ"
                                :show-labels="false"
                                multiple
                                @input="getProjectDetails"
                                track-by="id">
                            </multiselect>
                            <multiselect
                                v-else
                                v-model="form.project"
                                :options="optionsProject"
                                label="name"
                                placeholder="โครงการ"
                                :show-labels="false"
                                multiple
                                @input="getProjectDetails"
                                track-by="id">
                            </multiselect>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group row" v-if="form.no">
                        <label
                            class="col-sm-4 col-form-label text-capitalize text-right">
                            เลขที่ CS
                        </label>
                        <div class="col-sm-8">
                            <masked-input v-model="form.no"
                                          mask="CS111111111"
                                          placeholder="เลขที่ CS"
                                          class="form-control"
                                          type="text"/>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label
                            class="col-sm-4 col-form-label text-capitalize text-right">
                            ยอดจ่าย
                        </label>
                        <div class="col-sm-8">
                            <input type="number"
                                   class="form-control" v-model="totalPaid" disabled/>
                        </div>
                    </div>
                </div>
            </div>
            <!--table-->
            <div class="col-sm-12 table-responsive" v-if="form.project || form.projects">
                <table class="table table-bordered text-center">
                    <thead>
                    <tr>
                        <th scope="col">วันที่</th>
                        <th scope="col">รายการ</th>
                        <th width="250px" scope="col">ยอดชำระ</th>
                        <th scope="col">คงค้าง</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="data in form.rr_project_details">
                        <td>{{ data.date | moment("DD/MM/YYYY") }}</td>
                        <td>{{ data.name }}</td>
                        <td>
                            <input class="form-control" v-model="data.paid">
                        </td>
                        <td>{{ data.remaining | currency }}</td>
                    </tr>
                    <tr style="font-weight: bold">
                        <td colspan="2" style="text-align: right; font-weight: bold">รวม</td>
                        <td colspan="1">{{ totalPaid | currency }}</td>
                        <td colspan="1">{{ totalRemaining | currency }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="col text-center mt-3">
                <button class="btn btn-success" @click="goToTransaction" :disabled="disableSave">
                    <icon name="save"></icon>
                    บันทึก
                </button>
                &nbsp;&nbsp;
                <button type="button" class="btn btn-outline-secondary"
                        @click="goToRRPayoffList">
                    <icon name="times"></icon>
                    ยกเลิก
                </button>
            </div>
            <br/>
        </div>
        <b-modal size="lg" hide-header hide-footer ref="transaction_modal">
            <div>
                <payment-form-modal @submit="saveProjectPayment">
                </payment-form-modal>
            </div>
        </b-modal>
        <!--        <pre>{{form}}</pre>-->
    </div>
</template>

<script>
import {mapState} from "vuex";
import DatePicker from 'vue2-datepicker'
import moment from "moment";
import Multiselect from "vue-multiselect";
import PaymentFormModal from "./RRPayoffFormTransaction";
import MaskedInput from 'vue-masked-input'


export default {
    name: "project-payment",
    components: {DatePicker, Multiselect, PaymentFormModal, MaskedInput},
    props: {
        payment_type: {default: 1},
        status: {default: null}
    },
    created() {
        this.$store.dispatch("Vendor/getVendorAll")
        if (this.form.receive_date && !this.form.no && this.status == 1) {
            this.generateCSNumber();
        }
    },
    computed: {
        ...mapState({
            optionVendor: state => {
                return state.Vendor.vendorAll
            },
            form: state => {
                return state.RRPayoff.form
            },
            optionsProject: state => {
                return state.RRPayoff.RRProjectList
            }
        }),
        totalRemaining() {
            let total = 0;
            return this.form.rr_project_details.reduce((carry, detail) => {
                if (detail.remaining > 0) {
                    total = detail.remaining;
                }
                return carry + parseFloat(total);
            }, 0);
        },
        totalPaid() {
            return this.form.rr_project_details.reduce((carry, detail) => {
                if (detail.paid) {
                    return carry + parseFloat(detail.paid)
                } else {
                    return carry;
                }
            }, 0);
        },
        disableSave() {
            // //console.log(this.totalRemaining,this.totalPaid,this.form.project)
            if (this.totalRemaining < this.totalPaid) {
                return true;
            } else if (!this.form.project && this.form.projects && this.form.projects.length == 0) {
                return true;
            }
                // else if(!this.form.project){
                //     return true;
            // }
            else return this.form.rr_project_details.length < 1;
        }
    },
    data() {
        return {
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
            items: [
                {
                    text: "รายการตัดจ่าย",
                    to: {name: "rr-payoff-list"}
                },
                {
                    text: "เพิ่มเติม",
                    active: true
                }
            ],
        }
    },
    methods: {
        generateCSNumber() {
            let date = moment(this.form.receive_date).format('YYYY-MM-DD');
            this.$store.dispatch("RRPayoff/generateCS", date).then(res => {
                this.form.no = res;
            });
        },
        showTransactionModal() {
            this.$refs.transaction_modal.show();
        },
        hideTransactionModal() {
            this.$refs.transaction_modal.hide();
        },
        vendorLabel(option) {
            return `${option.vendor_id} - ${option.name}`
        },
        getProjectList() {
            this.form.project = null;
            if (this.form.vendor) {
                this.$store.dispatch("RRPayoff/getProjectList", this.form.vendor.id);
            }
        },
        getProjectDetails() {
            this.form.rr_project_details = [];
            if (this.form.project.length > 0) {
                let details = [];
                this.form.project.forEach(x => {
                    x.payment_details.forEach(detail => {
                        if (detail.remaining > 0) {
                            let sub_details = {
                                id: detail.id,
                                payment_id: detail.payment_id,
                                name: detail.name,
                                date: detail.date,
                                remaining: detail.remaining,
                                status: detail.status,
                                payment_date: detail.payment_date,
                                user_id: detail.user_id,
                                paid: "",
                            };
                            details.push(sub_details);
                        }
                    });
                })
                this.$store.dispatch("RRPayoff/setProjectDetails", details)
            }
        },
        goToTransaction() {
            this.form.total_amount = this.totalPaid;
            if (this.form.status == 2) {
                this.updateCsNumber();
            } else {
                this.showTransactionModal();
            }
        },
        updateCsNumber() {
            let data = {
                id: this.form.id,
                no: this.form.no,
            }
            this.$store.dispatch("RRPayoff/updateCsNo", data).then(() => {
                this.goToRRPayoffList();
            }).catch(() => {
                alert('ไม่สามารถอัพเดตเลข CS ได้')
            })
        },
        saveProjectPayment(value) {
            this.hideTransactionModal();
            if (value) {
                this.form.rr_payoff_details = [];
                this.form.rr_payoff_other_details = [];
                this.form.payment_type = 4; //ประเภทการจ่ายโครงการ
                this.form.status = this.status;
                if (this.form.rr_project_details.length > 0 && (this.form.project || this.form.projects.length > 0)) {
                    this.$store.dispatch("RRPayoff/saveRRpayoff", this.form.id).then(() => {
                        this.$store.dispatch("RRPayoff/getRRpayoff");
                    });
                    this.goToRRPayoffList();
                }
            }
        },
        goToRRPayoffList() {
            this.$router.push({
                name: "rr-payoff-list"
            })
        }
    }
}
</script>

<style lang="scss" scoped>
thead {
    background-color: darkgrey;
    color: black;
}

tbody {
    background-color: white;
    color: black;
}
</style>
